import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpandSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconExpandSimple"><Path fillRule="evenodd" clipRule="evenodd" d="M12 5.5C12 5.22386 12.2239 5 12.5 5H16.5C17.8807 5 19 6.11929 19 7.5V11.5C19 11.7761 18.7761 12 18.5 12C18.2239 12 18 11.7761 18 11.5V7.5C18 6.67157 17.3284 6 16.5 6H12.5C12.2239 6 12 5.77614 12 5.5ZM5.5 12C5.77614 12 6 12.2239 6 12.5V16.5C6 17.3284 6.67157 18 7.5 18H11.5C11.7761 18 12 18.2239 12 18.5C12 18.7761 11.7761 19 11.5 19H7.5C6.11929 19 5 17.8807 5 16.5V12.5C5 12.2239 5.22386 12 5.5 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpandSimple;
